import {Component, effect, input, model} from '@angular/core';
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";

@Component({
  selector: 'app-water-point-svg',
  imports: [],
  templateUrl: './water-point-svg.component.html',
  styleUrl: './water-point-svg.component.css'
})
export class WaterPointSvgComponent {

  width = input('50');
  height = input('50');
  lastAssetSample = input<Samples.AssetSample<any> | undefined>(undefined);
  innerColor = model('#48E9FF');
  outerColor = model('#219CE1');

  constructor() {
    effect(() => {
      const lastAssetSample = this.lastAssetSample();
      if (!lastAssetSample) return;

      switch (lastAssetSample.alertStatus) {
        case Samples.AlertStatus.LOW_ALERT: {
          this.outerColor.set('var(--primary-danger-color)');
          break;
        }
        case Samples.AlertStatus.LOW_WARNING: {
          this.outerColor.set('#FFA60C');
          break;
        }
        case Samples.AlertStatus.HIGH_ALERT: {
          this.outerColor.set('var(--primary-danger-color)');
          break;
        }
        case Samples.AlertStatus.HIGH_WARNING: {
          this.outerColor.set('#FFA60C');
          break;
        }
      }
    });
  }
}
